// extracted by mini-css-extract-plugin
export default {"ticketsStatusContent":"TicketsStatus_ticketsStatusContent__eKvf-","info":"TicketsStatus_info__Orx5-","dot":"TicketsStatus_dot__X1LCw"};